import { SCUIGeneralModal } from '@/atomic/molecules/SCUIGeneralModal/SCUIGeneralModal';
import { SCUIButton } from '@/atomic/atoms';
import { Box, FormControl, FormControlLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GROW } from '../growManagement.classes';

export const GrowEditModal = ({
    open,
    onClose,
    formState,
    setFormState,
    isLoading,
    onUpdate,
}: {
    open: boolean;
    onClose: () => void;
    formState: any;
    setFormState: (formState: any) => void;
    isLoading: boolean;
    onUpdate: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            sx={{
                '.MuiDialogTitle-root': {
                    fontSize: '16px !important',
                    fontWeight: 'bold',
                },
            }}
            open={open}
            onClose={onClose}
            width={'sm'}
            title={t('growManagement.modalTitle')}
        >
            <Box
                className={GROW.editModalContent}
                sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 36px 36px 36px' }}
            >
                <Box
                    className={GROW.editModalWarehouseRow}
                    sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}
                >
                    <p style={{ fontSize: '12px', fontWeight: 'bold' }}>{t('growManagement.warehouseCode')}:</p>
                    <p style={{ fontSize: '14px' }}>
                        {formState?.warehouseName
                            ? `${formState?.warehouseCode} - ${formState?.warehouseName}`
                            : formState?.warehouseCode}
                    </p>
                </Box>
                <Box
                    className={GROW.editModalStatusRow}
                    sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}
                >
                    <p style={{ fontSize: '12px', fontWeight: 'bold' }}>{t('growManagement.storeStatus')}:</p>
                    <FormControlLabel
                        control={
                            <Switch
                                className={GROW.inputSwitchStoreStatus}
                                checked={formState?.status}
                                color="primary"
                                disabled={isLoading}
                                onChange={() =>
                                    setFormState({
                                        ...formState,
                                        status: !formState?.status,
                                    })
                                }
                            />
                        }
                        label={formState?.status ? t('general.active') : t('general.passive')}
                    />
                </Box>
                <Box
                    className={GROW.editModalBufferRow}
                    sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}
                >
                    <p style={{ fontSize: '12px', fontWeight: 'bold' }}>{t('growManagement.growBufferSize')}:</p>
                    <TextField
                        className={GROW.inputNumberBufferSize}
                        sx={{ width: '75px' }}
                        placeholder={t('growManagement.growBufferSize')}
                        type="number"
                        value={formState?.growBufferSize}
                        onChange={(e) =>
                            setFormState({
                                ...formState,
                                growBufferSize: Math.max(0, Math.min(5, Number(e.target.value))),
                            })
                        }
                        slotProps={{
                            htmlInput: {
                                min: 0,
                                max: 5,
                            },
                        }}
                    />
                </Box>
                <Box
                    className={GROW.editModalDailyLimitRow}
                    sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}
                >
                    <p style={{ fontSize: '12px', fontWeight: 'bold' }}>{t('growManagement.dailyLimit')}:</p>
                    <TextField
                        className={GROW.inputNumberDailyLimit}
                        sx={{ width: '120px' }}
                        placeholder={t('growManagement.dailyLimit')}
                        type="number"
                        value={formState?.growDailyLimit ?? ''}
                        disabled={isLoading}
                        onChange={(e) => {
                            const value = e.target.value;
                            setFormState({
                                ...formState,
                                growDailyLimit: value === '' ? null : Math.max(0, Number(value)),
                            });
                        }}
                        slotProps={{
                            htmlInput: {
                                min: 0,
                            },
                        }}
                    />
                </Box>
                <Box
                    className={GROW.editModalStockSourceRow}
                    sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}
                >
                    <p style={{ fontSize: '12px', fontWeight: 'bold' }}>{t('growManagement.stockSource')}:</p>
                    <FormControl sx={{ width: '140px' }} size="small" error={formState.stockSource === -1}>
                        <Select
                            className={GROW.inputSelectStockSource}
                            value={formState.stockSource}
                            displayEmpty
                            onChange={(e) => setFormState({ ...formState, stockSource: e.target.value as number })}
                            disabled={isLoading}
                        >
                            <MenuItem value={-1} disabled>
                                <em>{t('growManagement.stockSourcePlaceholder')}</em>
                            </MenuItem>
                            <MenuItem value={1}>{t('growManagement.stockSourceWarehouse')}</MenuItem>
                            <MenuItem value={2}>{t('growManagement.stockSourceRayon')}</MenuItem>
                            <MenuItem value={3}>{t('growManagement.stockSourceFullStock')}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <SCUIButton
                    className={GROW.inputButtonModalSave}
                    style={{ marginTop: '8px' }}
                    type="primary"
                    text={t('general.save')}
                    disabled={isLoading}
                    onClick={onUpdate}
                    sizeType="default"
                    size="s"
                />
            </Box>
        </SCUIGeneralModal>
    );
};
